import {INotifications} from '../models/Notifications';

export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

export interface FetchNotifications {
  type: typeof FETCH_NOTIFICATIONS;
}

export interface FetchNotificationsError {
  type: typeof FETCH_NOTIFICATIONS_ERROR;
}

export interface FetchNotificationsSuccess {
  type: typeof FETCH_NOTIFICATIONS_SUCCESS;
  payload: INotifications[];
}

export interface AddNotification {
  type: typeof ADD_NOTIFICATION;
  payload: INotifications;
}

export type NotificationsActionTypes =
  | FetchNotifications
  | FetchNotificationsError
  | FetchNotificationsSuccess
  | AddNotification;
